module.exports = __webpack_public_path__ + "img/facebook_og_image-cutout.98201130.png";